import { Injectable, inject } from '@angular/core';
import { select, type Selector, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Injectable()
export class RosaStoreService {
    private _store = inject<Store<any>>(Store);

    getStoreInstantValue<T>(selector: Selector<any, T>): T {
        let value: any = null;
        this._store.pipe(select(selector), take(1)).subscribe(v => {
            value = v;
        });
        return value;
    }
}
